import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-measure-skeleton',
  standalone: true,
  imports: [SkeletonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './measure-skeleton.component.html',
  styleUrl: './measure-skeleton.component.scss',
})
export class MeasureSkeletonComponent {}
